import ExternalAnchorUrlService from 'services/application/anchor/subServices/external/subServices/ExternalAnchorUrlService';

export default {
	'services.externalAnchorUrlService': {
		class: ExternalAnchorUrlService,
	},
};
